import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { IEtiquetas } from "../../../shared/services/api/cadastros/ProdutosService";
const bwipjs = require("bwip-js");

const gerarCodigoBarras = async (ean: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement("canvas");
    try {
      bwipjs.toCanvas(canvas, {
        bcid: "ean13", 
        text: ean,
        fontSize: 8,
        scale: 3,
        height: 8,
        includetext: true, 
      });
      resolve(canvas.toDataURL("image/png"));
    } catch (err) {
      reject(err); 
    }   
  });
};  
   
const etiquetasPorLinha = 3;
const larguraEtiqueta = 210; // 33mm    
const alturaEtiqueta = 62.36;  // 22mm

const REtiquetas = async (dados: IEtiquetas[]) => {
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
  const colunasPorLinha = 3; // Altere este valor para definir o número de colunas
  const tabelaEtiquetas: any[] = [];

  const etiquetasProcessadas = await Promise.all(
    dados.map(async (item) => {
      const codigoBarras = await gerarCodigoBarras(item.ean);
      return {
        stack: [
          { text:`${item.fabrica}`, margin: [0, 13, 0, 0], fontSize: 8, alignment: "center" },
          { text: `${item.descricao}`, fontSize: 8, alignment: "center" },
          { image: codigoBarras, width: 70, margin: [15, 0, 0, 0], fontSize: 8, alignment: "left" },
         // { text: `${item.descricao}`, fontSize: 8, alignment: "center" },
        ],
        margin: [0, 5, 0, 0],
        border: [false, false, false, false],  
      };
    })     
  ); 

  // Agrupa as etiquetas em linhas com 3 colunas
  for (let i = 0; i < etiquetasProcessadas.length; i += colunasPorLinha) {
    tabelaEtiquetas.push(etiquetasProcessadas.slice(i, i + colunasPorLinha));
  } 

  const docDefinition: any = {     
    pageSize: {
      width: 300,  // 3 × 33mm → 99mm → 99 * 2.83465 ≈ 283.5pt
      height: 62, // altura para 10 linhas (10 x 22mm)
    },
    pageMargins: [0, 0, 0, 0],   
    pageOrientation: 'landscape',     
    content: [
      {      
        table: {
          widths: Array(colunasPorLinha).fill("*"), // Define colunas de tamanhos iguais
          // widths: [larguraEtiqueta, larguraEtiqueta, larguraEtiqueta],
          body: tabelaEtiquetas,
        },
      },   
    ],
  };      

  const pdfDocGenerator = pdfMake.createPdf(docDefinition);
  pdfDocGenerator.open();
};

export default REtiquetas;

